
import { createContext } from "react";
import { AppContextInterface, TConfEnteDati } from "Portal/mixin/types";


const defaultContext = {
    confEnte: null,
    userLogged: false,
    tabMenuAutenticatoVisibile: false
};

const defaultContextHeader: TConfEnteDati = {
      
        "domain": "localhost",
        "port": 8080,
        "ssl": '',
        "apps": [
          "core",
          "files",
          "images",
          "messenger",
          "portal",
          "demografici",
          "comunicazioni",
          "pagamenti",
          "moduli"
        ],
        "link_accessibilita": '',
        "tipo": "Demo",
        "nome": "OpenWeb",
        "codice_istat": "015168",
        "codice_ipa": "c_c986",
        "indirizzo": "Piazza Principale, 1 - 0123 Lorem Ipsum (XY)",
        "mail": "info@areademo.it",
        "telefono": "0123 45678",
        "fax": "0123 45679",
        "partita_iva": "00123456789",
        "codice_fiscale": "82000890853",
        "pec": "areademo@legalmail.it",
        "utente_loggato": false,
        "pec_obbligatoria": false,
        "password_normativa": true,
        "cellulare_obbligatorio": false,
        "conferma_cambio_cellulare": false,
        "clausole": false,
        "email_amministratore": "info@soluzionipa.it",
        "conferma_cambio_email": true,
        "url_app_feedback": "http://127.0.0.1:3000/feedbacks",
        "stemma": "stemma.png",
        "stemma_burger": "stemma.png",
        "titolo_header": ''
  
  }

export const AppCtx = createContext<AppContextInterface | null>({
    ...defaultContext,
    confEnte: defaultContextHeader,
    userLogged: false,
    appCorrente: "Portal"
});

export const AppCtxProvider = AppCtx.Provider
// export const AppCtxConsumer = AppCtx.Consumer



